import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getBffShoppingCart } from '@/core/services/fetchers';
import invalidateStaleShoppingCart from '@/core/utils/invalidate-stale-shopping-cart';
import { isInvalidShoppingCartError } from '@/core/utils/is-invalid-shopping-cart-error';

export type Variables = {
  cartId: string;
  languageCode?: string;
};

export const queryKey = (variables: Variables) => [
  'bff-shopping-carts',
  'shopping-cart',
  variables,
];

export const queryFn = async (variables: Variables) => {
  try {
    return await getBffShoppingCart({
      cartId: variables.cartId,
      languageCode: variables.languageCode,
    });
  } catch (error) {
    if (
      typeof window !== 'undefined' &&
      (await isInvalidShoppingCartError(error))
    ) {
      await invalidateStaleShoppingCart();
    }
    throw error;
  }
};

const useBffShoppingCartQuery = (
  variables: Variables,
  options?: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof queryFn>>>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    retry: false,
    ...options,
    queryKey: queryKey(variables),
    queryFn: () => queryFn(variables),
  });

export default useBffShoppingCartQuery;
